<ReportHeaderButtons></ReportHeaderButtons>

<div mat-dialog-content>

  <ReportHeader></ReportHeader>


  <table id="dataTable"
         mat-table
         [dataSource]="reportDataSource">


    <!-- Code Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef> Description </th>
      <td mat-cell *matCellDef="let item"> {{item.description}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="access">
      <th mat-header-cell *matHeaderCellDef> Access </th>
      <td mat-cell *matCellDef="let item"> {{item.access}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[20]"
                 showFirstLastButtons
                 (page)="pageEvent = onPageChange($event)">
  </mat-paginator>
</div>
